import { render, staticRenderFns } from "./OnlCgformButtonList.vue?vue&type=template&id=6d68732e&scoped=true&"
import script from "./OnlCgformButtonList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformButtonList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformButtonList.vue?vue&type=style&index=0&id=6d68732e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68732e",
  null
  
)

export default component.exports